<template>
    <div class="section-headline col-12 mb-4 d-flex justify-content-between align-items-end">
        <h2 class="font-family__tartine pl-3 pl-md-1 text-secondary">{{ msg }}</h2>
        <div v-if="hasEdit">
            <p v-if="!edit " class="edit m-2 pr-1" @click="$emit('click', true)">Bearbeiten <i class="fad fa-pen"></i>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SectionHeading',
    props: {
        msg: String,
        hasEdit: false,
        edit: Boolean,
    },

    data() {
        return {
            isEdit: false,
        };
    },

    methods: {
        toggleEdit(payload) {
            this.$emit('click', payload);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/abstracts/variables";

.section-headline {
    border-bottom: 3px dotted $green;
    padding-bottom: .5rem;
}

.edit {
    cursor: pointer;

    &:hover {
        color: $red;
    }
}
</style>
